import { inject } from '@angular/core'
import { Router, Routes } from '@angular/router'
import { AddCallPageComponent } from './add-call-page/add-call-page.component'
import { adminGuard } from './guards/admin.guard'
import { AppPageComponent } from './app-page/app-page.component'
import { authGuard } from './guards/auth.guard'
import { CallAccessRequestApprovePageComponent } from './call-access-request-approve-page/call-access-request-approve-page.component'
import { CallPageComponent } from './call/call-page.component'
import { CallsDashboardComponent } from './calls-dashboard/calls-dashboard.component'
import { ActivityLogComponent } from './activity-log/activity-log.component'
import { ClientDashboardComponent } from './client-dashboard/client-dashboard.component'
import { SlaDashboardComponent } from './sla-dashboard/sla-dashboard.component'
import { HangUpPageComponent } from './hang-up-page/hang-up-page.component'
import { ExtendPageComponent } from './extend-page/extend-page.component'
import { LoginPageComponent } from './login-page/login-page.component'
import { SettingsPageComponent } from './settings-page/settings-page.component'
import { CallSetupPageComponent } from './call-setup-page/call-setup-page.component'
import { unsavedChangesGuard } from './guards/unsaved-changes.guard'
import { TrainingPageComponent } from './training-page/training-page.component'
import { UploadCallPageComponent } from './upload-call-page/upload-call-page.component'
import { TeamsConsentComponent } from './teams/teams-consent.component'
import { TeamsPanelComponent } from './teams/teams-panel.component'
import { TeamsRouterComponent } from './teams/teams-router.component'
import { supportGuard } from './guards/support.guard'

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app',
  },
  {
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: 'teams',
    children: [
      { path: 'router', component: TeamsRouterComponent },
      { path: 'panel', component: TeamsPanelComponent },
      { path: 'consent', component: TeamsConsentComponent },
    ],
  },
  {
    path: 'meetings/:id/hang-up',
    pathMatch: 'full',
    component: HangUpPageComponent,
  },
  {
    path: 'meetings/:id/extend',
    pathMatch: 'full',
    component: ExtendPageComponent,
  },
  {
    path: 'app',
    component: AppPageComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'meetings/past',
      },
      // TODO Remove this after a while
      {
        path: 'calls/:id',
        redirectTo: '/app/meetings/:id',
      },
      {
        path: 'calls',
        redirectTo: '/app/meetings',
      },
      {
        path: 'meetings',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'past',
          },
          {
            path: 'past',
            component: CallsDashboardComponent,
            data: {
              mode: 'OWN_CALLS',
            },
          },
          {
            path: 'shared-with-me',
            component: CallsDashboardComponent,
            data: {
              mode: 'SHARED_WITH_ME',
            },
          },
          {
            path: 'new',
            component: AddCallPageComponent,
          },
          {
            path: ':id',
            component: CallPageComponent,
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: ':id/setup',
            component: CallSetupPageComponent,
            canDeactivate: [unsavedChangesGuard],
          },
          {
            path: ':id/admin',
            redirectTo: ({ params }) => {
              const callId = params['id']
              return `/app/support/meetings/${callId}`
            },
          },
          {
            path: ':id/approve-access-request',
            component: CallAccessRequestApprovePageComponent,
          },
        ],
      },
      {
        path: 'admin',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'dashboard',
          },
          {
            path: 'dashboard',
            component: ClientDashboardComponent,
            canActivate: [adminGuard],
            title: 'COMMON.ADMIN',
          },
          {
            path: 'activity-log',
            component: ActivityLogComponent,
            canActivate: [adminGuard],
            title: 'ACTIVITY_LOG.TITLE',
          },
          {
            path: 'sla-dashboard',
            component: SlaDashboardComponent,
            canActivate: [adminGuard],
            title: 'SLA_DASHBOARD.TITLE',
          },
          // TODO Delete this at some point as obsolete
          {
            path: '**',
            redirectTo: ({ url, queryParams }) => inject(Router).createUrlTree(['/app', 'support', ...url.map((segment) => segment.path)], { queryParams }),
          },
        ],
      },
      {
        path: 'settings',
        pathMatch: 'full',
        redirectTo: 'settings/calendar',
      },
      // TODO Delete these at some point as obsolete
      {
        path: 'settings/analytics',
        redirectTo: 'admin/dashboard',
      },
      {
        path: 'settings/activity-log',
        redirectTo: 'admin/activity-log',
      },
      {
        path: 'settings/:section',
        component: SettingsPageComponent,
      },
      {
        path: 'import',
        component: UploadCallPageComponent,
      },
      {
        path: 'training',
        component: TrainingPageComponent,
      },
      {
        path: 'support',
        loadChildren: () => import('./support/routes').then((module) => module.supportRoutes),
        canActivate: [supportGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'app',
  },
]
